<template>
  <main id="maincontent">
    <GlobalBreadcrumb v-if="!props.blok.removeBreadcrumb" :page-title="title" />
    <PageHeading
      :title="title"
      :published-date="blok.overview_published_date"
    />
    <div
      v-for="section in props.blok.body"
      :key="section._uid"
      :class="`background background-${section.component}`"
    >
      <StoryblokComponent
        :blok="section"
        :collection-news="collectionNews"
        class="section parent-bg"
        tag="section"
      />
    </div>
    <PageAuthorBlock
      v-if="pageAuthors.length"
      :authors="pageAuthors"
    />
  </main>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  story: {
    type: Object,
    required: true,
  },
});

const config = useRuntimeConfig();
const route = useRoute();

const newsData = computed(() => {
  return {
    newsId: props.story.id,
    showAllCard: true,
  };
});

const newsOptions = ref({});
const hubOptions = ref({});
const newsList = ref([]);
const newsHub = ref(null);
const [hub] = route.params.slug ?? [];

newsOptions.value = {
  version: config.public["storyblokVersion"],
  starts_with: `${config.public["storyblokCountryPrefix"]}/${hub}/`,
  ...(props.story.id && { excluding_ids: props.story.id }),
  content_type: "page-news-global",
  sort_by: "content.overview_published_date:desc",
};
hubOptions.value = {
  version: config.public["storyblokVersion"],
  content_type: "page-news-global-hub",
  starts_with: `${config.public["storyblokCountryPrefix"]}/${hub}/`,
};

newsList.value = await useCustomAsyncStoryblok("", newsOptions.value)
  .then((response) => response.value.stories)
  .catch((error) => {
    console.log(error);
    return [];
  });

newsHub.value = await useCustomAsyncStoryblok("", hubOptions.value)
  .then((response) => response.value?.stories[0])
  .catch((error) => {
    console.log(error);
    return null;
  });

const collectionNews = computed(() => {
  return getCollectionNews(newsList.value, newsData.value, newsHub.value);
});

let title = ref("");
title.value = props.blok?.overview_title;

const pageAuthors = computed(() => getActiveAuthors(props.blok.author));
</script>

<style lang="scss" scoped>
.main-title {
  line-height: 1;
}
.background-collection-news {
  @include pair-3;
}
.collection-news {
  :deep(.swiper-button-prev),
  :deep(.swiper-button-next) {
    &::before {
      background-color: var(--solid-03);
    }
  }

  :deep(.news-card):not(.is-special) {
    @include pair-7;
  }
}
</style>
